// extracted by mini-css-extract-plugin
export default {"form__group":"molecules_form__group__Wesep","alignLeft":"molecules_alignLeft__StSB0"};